<template>
  <el-dialog
    :visible.sync="showEdit"
    width="50%"
    :append-to-body="true"
    @open="handleOpen"
    :modal-append-to-body="true"
    destroy-on-close
    title="企业信息"
    @closed="handleClose"
    :close-on-click-modal="false"
    class="station-edit"
  >
    <el-form ref="form" :model="form" label-position="top" :rules="rules">
      <el-row>
        <el-col :span="12">
          <el-form-item prop="name" label="请设置公司名称">
            <el-input size="mini" v-model="form.name" type="text" :rows="1" :maxlength="36" placeholder="请设置公司名称" show-word-limit />
          </el-form-item>
        </el-col>
      </el-row>
      <el-form-item label="请上传公司Logo">
        <love-element-upload
          :list-type="uploadOption.listType"
          :drag="uploadOption.drag"
          :allow-type="uploadOption.allowType"
          :allow-size="uploadOption.allowSize"
          :disabled="uploadOption.disabled"
          :limit="uploadOption.limit"
          :multiple="uploadOption.multiple"
          :love-path="uploadOption.lovePath"
          :file-list="fileList.image"
          :accept="uploadOption.accept"
          :show-file-list="uploadOption.showFileList"
          @preview="onPreview"
          @remove="onRemove"
          @success="onSuccess" />
      </el-form-item>
      <el-row >
        <el-col :span="12">
          <el-form-item label="行业" prop="industry">
            <el-input size="mini" v-model="form.industry" placeholder="请填写公司行业"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="12">
          <el-form-item label="请填写公司地址" prop="address">
            <el-input size="mini" v-model="form.address" placeholder="请填写公司地址"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="12">
          <el-form-item label="请填写公司简介" prop="description">
            <el-input
              size="mini"
              type="textarea"
              :maxlength="200"
              show-word-limit
              placeholder="请填写公司简介"
              :autosize="{minRows: 4}"
              v-model="form.description">
            </el-input>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <div slot="footer">
      <el-button size="medium" type="info" @click="handleClose">取消</el-button>
      <axj-button color="#00adb5" v-show="isCreate!=2" size="max" @click="handleSubmit">保存</axj-button>
    </div>
  </el-dialog>
</template>

<script>
const defaultForm = {
  user_id: undefined,
  user_avatar: '',
  user_name: '',
  is_auth: 0,
  name: '',
  background_img: '',
  description: '',
  is_gopublic: 1,
  source_directory: '',
  address: '',
  type: '',
  industry: '',
  number_staff: undefined
}
import { fetchServiceWorkCompanyList,createServiceWorkCompany,updateServiceWorkCompany } from "@/api/axj-service/axj-service-work"
export default {
  name: "business",
  props:{
    show:{
      type:Boolean,
      default:false
    },
    isCreate: {
      type: Boolean,
      default: false
    }
  },
  computed:{
    info(){
      return this.$store.getters.getUser.info
    },
    resourcePrefix(){
      return this.$store.getters.getResourcePrefix
    }
  },
  data(){
    return{
      showEdit:false,
      // 记录公司唯一id
      id: undefined,
      form: Object.assign({}, defaultForm),
      // love element upload 上传文件组件参数
      uploadOption: {
        listType: "picture-card",
        drag: false,
        multiple: true,
        allowType: ["image/jpg", "image/jpeg", "image/png"],
        disabled: false,
        limit: 1,
        lovePath:{
          module: "assistant/work/company",
          source_directory: "",  // this.uid + '_' + Date.parse(new Date()) / 1000
        },
        allowSize: 2,
        accept: 'image/*',
        showFileList: true
      },
      // fileList
      fileList: {
        image: []
      },
      // web view preview
      webPreview: false,
      // loading
      loading: false,
      typeListOptions: [{
        value: "民营",
        label: "民营"
      }, {
        value: "国企",
        label: "国企"
      }, ],
      // 数据验证
      rules: {
        name: [
          { required: true, message: '公司标名称不能为空', trigger: 'change' }
        ],
        // thumb: [
        //   { required: true, message: '请上传公司LOGO', trigger: 'blur,change' }
        // ],
        industry: [
          { required: true, message: '请填写文章行业信息', trigger: 'blur,change' }
        ],
        number_staff: [
          { required: true, message: '请填写公司大致员工数', trigger: 'blur,change' }
        ],
        description: [
          { required: true, message: '请填写公司简介', trigger: 'blur,change' }
        ],
        address: [
          { required: true, message: '请填写公司地址', trigger: 'change' }
        ],
      }
    }
  },
  watch:{
    show(v){
      this.showEdit=v
    }
  },
  methods:{
    handleOpen(){
      // 初始化一些公用数据
      // this.initData()
      // 创建 sourceDirectory 规则为 [uuid_打开这页面的时间戳]
      this.uploadOption.lovePath.source_directory = this.info.id + '_' + Date.parse(new Date()) / 1000
      // 判断编辑状态
      if (!this.isCreate) {
        // 编辑公司，使用route中的id获取form
        // const id = this.$store.getters.user

        let id= this.$store.getters.getUser.info.ServiceWorkUser.id
        // data 中的 id，记录待使用

        // 获取公司数据
        this.handleGetCompanyData(id)
      } else {
        // 发布公司 form 为 default form
        this.form = Object.assign({}, defaultForm)
      }
    },
    handleClose(){
      this.fileList={
        image: []
      }
      this.uploadOption={
        listType: "picture-card",
          drag: false,
          multiple: true,
          allowType: ["image/jpg", "image/jpeg", "image/png"],
          disabled: false,
          limit: 1,
          lovePath:{
          module: "assistant/work/company",
            source_directory: "",  // this.uid + '_' + Date.parse(new Date()) / 1000
        },
        allowSize: 2,
          accept: 'image/*',
          showFileList: true
      }
      this.$emit("update:show",false)
    },
    handleGetCompanyData(id) {
      fetchServiceWorkCompanyList({
        where:JSON.stringify({
          user_id:id
        })
      })
        .then(res=> {
          const data = res.data.lists[0]
          this.id = parseInt(data.id)
          // 常规数据
          console.log(data)
          this.form = Object.assign({},this.defaultForm, data)
          // 去掉form中的多余属性
          this.$delete(this.form,'created_at')
          this.$delete(this.form,'updated_at')
          this.$delete(this.form,'Count')
          // 若数据库中已经存放了该公司的 source directory
          if (data.source_directory != '') {
            // uploadOption 中也使用该 source directory
            this.uploadOption.lovePath.source_directory = data.source_directory
          }
          // 把头像放入 fileList
          var logo = {
            name: data.name+'LOGO',
            url: data.thumb.indexOf('http') >= 0?data.thumb:this.resourcePrefix.url + data.thumb
          }
          this.fileList.image.push(logo)
        })
    },
    onSelectedType(event) {
      this.form.type = event
    },
    onPreview(file) {
      console.log(file)
      console.log(this.fileList)
    },
    onRemove(file, fileList) {
      this.form.thumb = ''
      this.fileList.image = []
    },
    onSuccess(response) {
      // 保存返回值
      const file = {
        uid: response.uid,
        name: response.old_name,
        url: response.url,
        status: "success"
      }
      this.fileList.image[0] = file
      this.form.thumb = response.url
    },
    handleSubmit(status) {
      // 表单校验
      this.$refs['form'].validate(async (valid) => {
        if(valid) {
          // 补充表单信息
          this.form.status = status
          // uploadOption.lovePath.source_directory 中保存的为公司的 source_directory
          this.form.source_directory = this.uploadOption.lovePath.source_directory
          // 去掉URL前缀
          this.form.thumb = this.form.thumb.indexOf('http')>=0?this.form.thumb.slice(this.resourcePrefix.url.length):this.form.thumb
          // 创建公司时
          if(this.isCreate) {
            this.form.user_id = this.info.id
            this.form.user_name = this.info.nickname
            this.form.user_avatar = this.info.avatar
            await this.handleCreateCompany(this.form)
            this.$nextTick(()=> {
              // this.$router.go(-1)
              this.$emit('editSuccess')
            })
          } else {
            await this.handleUpdateCompany(this.form)
            await this.handleUpdateCompanyStatus(this.form)
            this.$nextTick(()=> {
              this.$emit('editSuccess')
            })
          }
        }
      })
      console.log(this.form)
    },
    handleCloseSubmit() {
      // 取消修改
      this.$nextTick(()=> {
        this.$router.go(-1)
      })
    },
    handleCreateCompany(form) {
      return new Promise((resolve, reject)=> {
        this.loading = true
        createServiceWorkCompany(form)
          .then(res=> {
            this.$notify({
              message: form.status == 0 ? '保存成功!' : '公司已成功发布!',
              type: 'success',
              duration: 2000
            })
            this.loading = false
            resolve(res.id)
          })
          .catch(err=> {
            this.$notify.error({
              message: '公司发布失败，请重试!',
              duration: 2000
            })
            this.loading = false
            reject(err)
          })
      })
    },
    handleUpdateCompany(form) {
      return new Promise((resolve, reject)=> {
        // 修改公司内容
        this.loading = true
        updateServiceWorkCompany(form)
          .then(res=> {
            resolve(res)
          })
          .catch(err=> {
            reject(err)
          })
      })
    },
    handleUpdateCompanyStatus(form) {
      return new Promise((resolve, reject)=> {
        // 如果 thumb_sum 等从 非0 再修改为 0 的时候就需要用 where 修改了
        updateServiceWorkCompany({
          id: form.id,
          where: JSON.stringify({
            status: form.status,
            is_comment: form.is_comment
          })
        })
          .then(res=> {
            this.$notify({
              message: form.status == 0 ? '保存成功!' : '公司修改成功!',
              type: 'success',
              duration: 2000
            })
            this.loading = false
            resolve(res)
          })
          .catch(err=> {
            this.$notify.error({
              message: '修改公司失败，请重试!',
              duration: 2000
            })
            this.loading = false
            reject(err)
          })
      })
    },
  }
}
</script>

<style slot-scope lang="scss">

</style>



// WEBPACK FOOTER //
// src/views/axj-service/axj-work/component/business/index.vue